<template>
    <h1>Bonjour vous vous êtes sûrement perdus !</h1>
</template>